import { offerActionTypes } from './Constants';
import { change } from 'redux-form';

export function getOfferAbility(data) {
	return {
		type: offerActionTypes.GET_OFFER_ABILITY,
		payload: {
			data,
		},
	};
}

export function getOfferAbilitySuccess() {
	return {
		type: offerActionTypes.GET_OFFER_ABILITY_SUCCESS,
	};
}

export function getOfferAbilityError(data) {
	return {
		type: offerActionTypes.GET_OFFER_ABILITY_ERROR,
		payload: {
			data,
		},
	};
}

export function getFullAddress(data) {
	return {
		type: offerActionTypes.GET_FULL_ADDRESS,
		payload: {
			data,
		},
	};
}

export function getFullAddressSuccess(data) {
	return {
		type: offerActionTypes.GET_FULL_ADDRESS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getFullAddressError() {
	return {
		type: offerActionTypes.GET_FULL_ADDRESS_ERROR,
	};
}

export function offerRequest(data) {
	return {
		type: offerActionTypes.OFFER_REQUEST,
		payload: {
			data,
		},
	};
}

export function offerRequestSuccess(data) {
	return {
		type: offerActionTypes.OFFER_REQUEST_SUCCESS,
		payload: {
			data,
		},
	};
}

export function offerRequestError() {
	return {
		type: offerActionTypes.OFFER_REQUEST_ERROR,
	};
}

export function changeFormField(formName, fieldName, value) {
	return change(formName, fieldName, value);
}

export function clearState() {
	return {
		type: offerActionTypes.CLEAR_OFFER_STATE,
	};
}

export function acceptReverseTrialOfferRequest() {
	return {
		type: offerActionTypes.ACCEPT_REVERSE_TRIAL_OFFER_REQUEST,
	};
}
